module.exports = __webpack_public_path__ + "img/lazada.caf787cc.png";